import { Directive, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[arsultimaHighlight]',
})
export class HighlightDirective implements OnChanges {
  @Input() arsultimaHighlight: string;

  @Input() currentId: string;

  @Input() transitionDuration = 2000;

  @HostBinding('class.element-highlight') get wrapperClass() {
    return true;
  }
  @HostBinding('class.highlight') get highlightClass() {
    return this.highlight;
  }

  highlight = false;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    const { arsultimaHighlight, currentId } = changes;

    if (arsultimaHighlight?.currentValue && currentId?.currentValue) {
      this.highlighthWhenHighlightIdEqualElementID(this.arsultimaHighlight, this.currentId);
    }
  }

  private highlighthWhenHighlightIdEqualElementID(highlightId: string, currentId: string) {
    if (highlightId === currentId) {
      this.highlight = true;
      setTimeout(() => {
        this.highlight = false;
      }, this.transitionDuration);
    }
  }
}
